// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jP6rW","footer":"styles_footer__3eKQZ","passCodeTooltip":"styles_passCodeTooltip__F6KTh"};